(function($) {
  'use strict';

  $('.footer_accordion').find('.accordion-toggle').on('click', function() {
    // Expand or collapse this panel
    $(this).parent().toggleClass('showing');
  });
}(window.jQuery || window.Zepto || window.$));
